import { useId, type InputHTMLAttributes, type ReactNode } from 'react';
import { lowercasesType, uppercasesType } from '../domain/text.ts';
import { lowercaseChange, uppercaseChange } from './uppercase.ts';

interface FieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  label: string;
  error?: string | undefined;
  hint?: ReactNode;
  required?: boolean;
}

// Todo texto escrito se convierte a mayúsculas al escribir; el correo, a minúsculas, y la contraseña queda
// tal cual (regla en AGENTS.md).
export function Field({ label, error, hint, required, onChange, ...input }: FieldProps) {
  const id = useId();
  const hintId = hint ? `${id}-hint` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  const describedBy = [hintId, errorId].filter(Boolean).join(' ') || undefined;
  const uppercase = uppercasesType(input.type);
  const lowercase = lowercasesType(input.type);
  return (
    <div className={`field${error ? ' field-invalid' : ''}`}>
      <label htmlFor={id}>
        {label}
        {required ? <span aria-hidden="true"> *</span> : null}
      </label>
      <input
        autoCapitalize={uppercase ? 'characters' : lowercase ? 'none' : undefined}
        {...input}
        onChange={uppercase ? uppercaseChange(onChange) : lowercase ? lowercaseChange(onChange) : onChange}
        id={id}
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
      />
      {hint ? (
        <p id={hintId} className="field-hint">
          {hint}
        </p>
      ) : null}
      {error ? (
        <p id={errorId} className="field-error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
